import { fork } from 'redux-saga/effects';
import heroBannerSaga from './heroBanner';
import megaphoneBannerSaga from './megaphoneBanner';
import webCardsSaga from './webCards';

export default function* rootSaga() {
  yield fork(heroBannerSaga);
  yield fork(megaphoneBannerSaga);
  yield fork(webCardsSaga);
}
